module.exports = __webpack_public_path__ + "img/W-13.0af96d81.jpg";